import type { VNode, } from "vue"

export function useTemplate<T,>() {
  let render: ((props?: T) => VNode[]) | undefined
  const DefineTemplate = defineComponent({
    setup(_, { slots, },) {
      return () => {
        render = slots.default
        return null
      }
    },
  },)
  const UseTemplate = (props?: T,) => render?.(props,)
  return {
    DefineTemplate,
    UseTemplate,
  }
}
